import { getKakaoRedirectUrl, getNaverRedirectUrl } from 'lib/api';
import util from './social_utils';

export default class SocialLogin {
  // 카카오 로그인
  kakaoLogin() {
    const src = 'https://developers.kakao.com/sdk/js/kakao.min.js';
    util.checkScript('kakao', src, openPopup);

    function openPopup() {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY);
      }

      window.Kakao.Auth.authorize({
        redirectUri: getKakaoRedirectUrl(),
      });
    }
  }

  // 네이버 로그인
  naverLogin(value = true) {
    const src = 'https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.2.js';
    util.checkScript('naver', src, openPopup);

    function openPopup() {
      const naverLogin = new window.naver.LoginWithNaverId({
        clientId: process.env.REACT_APP_NAVER_CLIENT_ID,
        callbackUrl: getNaverRedirectUrl(),
        isPopup: false,
        loginButton: { color: 'green', type: 3, height: 60 },
        callbackHandle: true,
      });
      naverLogin.init();

      console.log(naverLogin, window.naver);

      const btn = document.getElementById('naverIdLogin').firstChild;
      btn.click();
    }
  }
}
